import * as yup from 'yup';
export var CurveManagerDialogs;
(function (CurveManagerDialogs) {
    CurveManagerDialogs["CreateCurve"] = "CreateCurve";
    CurveManagerDialogs["EditCurve"] = "EditCurve";
})(CurveManagerDialogs || (CurveManagerDialogs = {}));
export var CurveType;
(function (CurveType) {
    CurveType["PRESSURE_CURVE"] = "pump_curve";
    CurveType["HEAD_CURVE"] = "head_curve";
    CurveType["TANK_CURVE"] = "tank_curve";
    CurveType["POWER_CURVE"] = "power_curve";
    CurveType["EFFICIENCY_CURVE"] = "efficiency_curve";
    CurveType["SYSTEM_CURVE"] = "system_curve";
})(CurveType || (CurveType = {}));
export const curveDataSchema = yup.object().shape({
    curveName: yup.string().trim().required('Curve name is required'),
    curveType: yup.string().oneOf(Object.values(CurveType)),
    curveData: yup.object().shape({
        depthArray: yup.array().of(yup.number()),
        volumeArray: yup.array().of(yup.number()),
        xSeries: yup.object().shape({
            type: yup.string(),
            unit: yup.string(),
        }),
        ySeries: yup.object().shape({
            type: yup.string(),
            unit: yup.string(),
        }),
    }),
});
export var CurveOperationType;
(function (CurveOperationType) {
    CurveOperationType["CREATE"] = "create";
    CurveOperationType["UPDATE"] = "update";
    CurveOperationType["DELETE"] = "delete";
})(CurveOperationType || (CurveOperationType = {}));
export const CURVE_TYPES = 'pump_curve,head_curve,tank_curve,power_curve,efficiency_curve,system_curve';
